export const formatTimeStatus = (totalSeconds) => {
    const hrs = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;
    return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

export const getStatusStyles = (currentStatus, breakStatuses = []) => {
    if (currentStatus.startsWith('break_')) {
        const breakId = parseInt(currentStatus.split('_')[1]);
        const breakItem = breakStatuses.find(b => b.id === breakId);
        return {
            bg: '#fff7e6',
            border: '#ffd591',
            text: '#fa8c16',
            label: breakItem ? breakItem.name.toUpperCase() : 'EN RECESO'
        };
    }

    switch (currentStatus) {
        case 'available': return { bg: '#f6ffed', border: '#b7eb8f', text: '#52c41a', label: 'DISPONIBLE' };
        case 'online': return { bg: '#f5f5f5', border: '#d9d9d9', text: '#8c8c8c', label: 'NO DISPONIBLE' };
        case 'offline': return { bg: '#f5f5f5', border: '#d9d9d9', text: '#8c8c8c', label: 'NO DISPONIBLE' };
        case 'incall': return { bg: '#fff1f0', border: '#ffa39e', text: '#f5222d', label: 'EN LLAMADA' };
        case 'ringing': return { bg: '#e6f7ff', border: '#91d5ff', text: '#1890ff', label: 'TIMBRANDO' };
        case 'wrapup': return { bg: '#fffbe6', border: '#ffe58f', text: '#d4b106', label: 'ESPERANDO FORMULARIO' };
        case 'break': return { bg: '#fff7e6', border: '#ffd591', text: '#fa8c16', label: 'EN RECESO' }; // Default break style
        default: return { bg: '#f5f5f5', border: '#d9d9d9', text: '#8c8c8c', label: 'NO DISPONIBLE' };
    }
};
